var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskyAuth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6493 12.9771C24.6493 19.3661 19.4713 24.5431 13.0833 24.5431C6.69533 24.5431 1.51733 19.3661 1.51733 12.9771C1.51733 6.58911 6.69533 1.41211 13.0833 1.41211C19.4713 1.41211 24.6493 6.58911 24.6493 12.9771Z",
    stroke: "#6B696A",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0419 15.101H11.9329L11.6009 7.41602H14.3739L14.0419 15.101ZM11.5239 17.496C11.5239 17.114 11.6619 16.801 11.9369 16.557C12.2119 16.312 12.5559 16.19 12.9679 16.19C13.3799 16.19 13.7239 16.312 13.9999 16.557C14.2749 16.801 14.4129 17.114 14.4129 17.496C14.4129 17.876 14.2749 18.189 13.9999 18.434C13.7239 18.678 13.3799 18.8 12.9679 18.8C12.5559 18.8 12.2119 18.678 11.9369 18.434C11.6619 18.189 11.5239 17.876 11.5239 17.496Z",
    fill: "#368FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskyAuth);
export default __webpack_public_path__ + "static/media/risky_auth.3dfcc4b82aa11162545208ef9d349e22.svg";
export { ForwardRef as ReactComponent };